import { useCallback } from "react";
import { useDrawerDispatch } from "@/context/DrawerContext";

const useOpenDrawer = (drawerComponent: Function) => {
  const dispatch = useDrawerDispatch();

  return useCallback(
    (data) => {
      dispatch({
        type: "OPEN_DRAWER",
        drawerComponent,
        data,
      });
    },
    [dispatch, drawerComponent]
  );
};

export default useOpenDrawer;
